import toastr from 'react-hot-toast';
import { useMutation } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { MemoryAttributes, SingleMemoryResponse } from 'types/Memory';
import { useWorkspaceContext } from 'hooks/common/useWorkspaceContext';

type MutationVariables = Partial<MemoryAttributes>;

export function useAddMemory() {
  const { currentWorkspaceID } = useWorkspaceContext();

  const addMemory = (memoryAttributes: MutationVariables) => {
    const body = {
      data: {
        type: 'memories',
        attributes: {
          ...memoryAttributes,
          workspaceID: currentWorkspaceID,
          defaultMinimumRelevance: 0.7,
          defaultLimit: 3,
          memoryStatusTypeID: 3,
          statusDescription: '',
          note: '',
        },
      },
    };
    return fetchWrapper<SingleMemoryResponse>({
      url: `memories`,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('addMemory', addMemory, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to add Memory: ${error.message}`);
      }
    },
  });
}
